import { ApolloLink, Observable } from "@apollo/client";
const callbacks = new Set();
export function registerComponentKillCallback(callback) {
    callbacks.add(callback);
    return ()=>{
        callbacks.delete(callback);
    };
}
export default function createComponentKillswitchLink() {
    return new ApolloLink(function componentKillswitchLink(operation, forward) {
        return new Observable(function componentKillswitchObserver(observer) {
            const subscription = forward(operation).subscribe({
                next: function componentKillswitchLinkNext(result) {
                    const context = operation.getContext();
                    var _context_responses, _ref;
                    const responses = (_ref = (_context_responses = context.responses) !== null && _context_responses !== void 0 ? _context_responses : context.response && [
                        context.response
                    ]) !== null && _ref !== void 0 ? _ref : [];
                    responses.forEach((response)=>{
                        var _response_headers_get, _response_headers;
                        const killswitchHeader = response === null || response === void 0 ? void 0 : (_response_headers = response.headers) === null || _response_headers === void 0 ? void 0 : (_response_headers_get = _response_headers.get) === null || _response_headers_get === void 0 ? void 0 : _response_headers_get.call(_response_headers, 'X-Component-Killswitch');
                        if (killswitchHeader) {
                            const componentIds = killswitchHeader.split(',').map((id)=>id.trim()).filter((id)=>id.length > 0);
                            if (componentIds.length > 0) {
                                callbacks.forEach((callback)=>{
                                    callback(componentIds);
                                });
                            }
                        }
                    });
                    return observer.next(result);
                },
                error: function componentKillswitchLinkError(error) {
                    return observer.error(error);
                },
                complete: function componentKillswitchLinkComplete() {
                    return observer.complete();
                }
            });
            return function componentKillswitchLinkUnsubscribe() {
                if (subscription) {
                    subscription.unsubscribe();
                }
            };
        });
    });
}

//# sourceMappingURL=createComponentKillswitchLink.js.map